import newTranslations from './lv_new_translations';

export const lv = {
    translations: {
        ...newTranslations,
        // Main title
        "darbuotojų_apklausa": "Dažādības un iekļaušanas novērtējums",
        "Įvairovės ir įtraukties vertinimas": "Dažādības un iekļaušanas novērtējums",
        "1. Socialinės distancijos vertinimas": "Sociālās distances novērtējums",
        "Socialinės distancijos vertinimas": "Sociālās distances novērtējums",
        "2. Požiūris apie įvairovę ir įtrauktį darbo vietoje": "Dažādības un iekļaušanas novērtējums darbavietā",
        "3. Įdarbinimo vertinimas": "Darbinieku pieņemšanas novērtējums",
        "4. Įvairovės ir įtraukties vertinimas darbo vietoje": "Dažādības un iekļaušanas novērtējums darba vietā",
        "Įvairovės ir įtraukties vertinimas darbo vietoje": "Dažādības un iekļaušanas novērtējums darba vietā",
        "5. Darbuotojų gerovė": "Darbinieku labklājība",
        "6. Įtraukimas į sprendimų priėmimą": "Iesaistīšana lēmumu pieņemšanā",
        "7. Socialinės ir demografinės charakteristikos": "Sociālās un demogrāfiskās charakteristikas",
        "8. Kiti klausimai (neprivaloma)": "Citi jautājumi (nav obligāti)",
        "Darbuotojų gerovė": "Darbinieku labklājība",
        "Įtraukimas į sprendimų priėmimą": "Iesaistīšana lēmumu pieņemšanā",
        "Socialinės ir demografinės charakteristikos": "Sociālās un demogrāfiskās charakteristikas",
        "Kiti klausimai (neprivaloma)": "Citi jautājumi (nav obligāti)",
        "Įdarbinimo vertinimas": "Darbinieku pieņemšanas novērtējums",

        "rodytiVisus": "Rādīt visu",
        "pasirinkti": "Aptaujas tips",
        "Darbuotojų apklausa": "Darbinieku aptauja",
        "Organizacijos atstovės/-o apklausa": "Organizācijas pārstāvja aptauja",
        "Darbuotojo forma": "Darbinieku aptauja",
        "Įmonės forma": "Organizācijas pārstāvja aptauja",
        "filtruoti": "Filtrēt",
        "export_excel": "Lejupielādēt Excel",
        "export_csv": "Lejupielādēt CSV",
        "export_preparing": "Tiek sagatavots...",
        "metai": "Gads",
        "atliko": "Veica: {{kiek}}",
        "1.1: Ar sutiktumėte savo kaimynystėje gyventi su žemiau išvardintais žmonėmis?": "Vai jūs piekrītat dzīvot kaimiņos ar tālāk minētajiem cilvēkiem?",
        "1.2: Ar sutiktumėte dirbti toje pačioje įmonėje su žemiau išvardintais žmonėmis?": "Vai jūs piekrītat strādāt tajā pašā uzņēmumā ar tālāk minētajiem cilvēkiem?",
        "2.1: Ar, Jūsų manymu, Jūsų kolektyvas yra įvairus pagal:": "Vai, jūsuprāt, jūsu kolektīvs ir daudzveidīgs",
        "2.1: Ar, Jūsų manymu, Jūsų kolektyvas yra įvairus": "Vai, jūsuprāt, jūsu kolektīvs ir daudzveidīgs",
        "2.2: Ką darbovietė daro, kad užtikrintų įvairovę ir darbuotojų gerovę?": "Ko darba vieta dara, lai nodrošinātu daudzveidību un darbinieku labklājību?",
        "2.3: Ko norėtumėte, kad darbovietė imtųsi siekiant užtikrinti įvairovę ir darbuotojų gerovę?": "Ko jūs vēlētos, lai darba vieta darītu, lai nodrošinātu daudzveidību un darbinieku labklājību?",
        "3.1: Klausimai darbo pokalbio metu": "Jautājumi darba intervijas laikā",
        "3.1: Ar darbo pokalbio metu įmonė Jūsų klausė apie:": "Jautājumi darba intervijas laikā",
        "3.2: Ar patyrėte diskriminaciją arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje?": "Vai esat piedzīvojis diskrimināciju vai netaisnīgu attieksmi pašreizējā darba vietā?",
        "3.2: Jeigu dabartinis darbdavys ieškotų darbuotojų ir turėtų du kandidatus su vienoda patirtimi ir kvalifikacijomis, kurie iš šių kriterijų galėtų daryti įtakos sprendimui dėl vieno arba kito kandidato pasirinkimo?": "Vai esat piedzīvojis diskrimināciju vai netaisnīgu attieksmi pašreizējā darba vietā?",
        "4.1: Ar darbovietėje girdėjote nemalonių komentarų ar juokelių apie save arba kitus asmenis?": "Vai esat dzirdējis nepatīkamus komentārus vai jokus par sevi vai citiem cilvēkiem darba vietā?",
        "4.2: Hipotetinių situacijų vertinimas": "Hipotētisko situāciju novērtējums",
        "4.2: Kaip Jūs vertinate šias hipotetines situacijas:": "Hipotētisko situāciju novērtējums",
        "4.5: Jei Jūs ar Jūsų kolega patirtų diskriminacijos darbo vietoje, ar jaustumėtės saugus  apie tai papasakoti kolegams?": "Ja jūs vai jūsu kolēģis piedzīvotu diskrimināciju darba vietā, vai jūs jūstaties droši, runājot par to ar kolēģiem?",
        "4.6: Ar Jūsų darbo vietoje yra saugus pranešimo kanalas?": "Vai jūsu darba vietā ir drošs ziņošanas kanāls?",
        "4.7:  Jei Jūs ar Jūsų kolega patirtų diskriminaciją darbo vietoje, ar norėtumėte apie tai pranešti?": "Ja jūs vai jūsu kolēģis piedzīvotu diskrimināciju darba vietā, vai vēlētos par to ziņot?",
        "4.3: Ar darbuotojai patyrė diskriminacijos arba ar su Jais buvo elgiamasi nesąžiningai dabartinėje darbo vietoje": "Vai darbinieki ir piedzīvojuši diskrimināciju vai netaisnīgu attieksmi pašreizējā darba vietā",
        "4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami?": "Vai jūs zināt kolēģi, kurš ir piedzīvojis diskrimināciju darba vietā?",
        "5.1: Kiek žinote apie iššūkius, su kuriais susiduria skirtingi gyventojai?": "Cik daudz jūs zināt par izaicinājumiem, ar kuriem saskaras dažādi iedzīvotāji?",
        "5.1: Kiek žinote apie iššūkius, su kuriais susiduria gyventojai, kurie yra:": "Cik daudz jūs zināt par izaicinājumiem, ar kuriem saskaras dažādi iedzīvotāji?",
        "5.2: Darbuotojų savijauta darbe": "Darbinieku pašsajūta darbā",
        "5.2: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Darbinieku pašsajūta darbā",
        "5.3: Darbovietės vertinimas": "Darba vietas novērtējums",
        "5.3: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Darba vietas novērtējums",
        "5.4:  Ar dabartinėje darbo vietoje teko patirti patyčių ar priekabiavimo?": "Vai esat piedzīvojis iebiedēšanu vai uzmākšanos pašreizējā darba vietā?",
        "6.1: Darbuotojų įtraukimas į sprendimų priėmimą": "Darbinieku iesaiste lēmumu pieņemšanā",
        "6.1: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Darbinieku iesaiste lēmumu pieņemšanā",
        
        "deaktyvuoti": "Deaktivizēt",
        "Nera_ats": "Nav atbilžu",
        "Nera_atsakymu": "Nav atbilžu",
        "Prašome atsakyti į klausimą": "Lūdzu, atbildiet uz jautājumu",
        "prisijungti": "Pieslēgties",
        "registruotis": "Reģistrēties",
        "login_email": "E-pasts",
        "vardas_pavarde": "Vārds, Uzvārds",
        "imones_pav": "Uzņēmuma nosaukums",
        "telNr": "Tālrunis",
        "login_pass": "Parole",
        "esu_organizacijos_atstovas": "Esmu pilnvarots organizācijas pārstāvis un varu tās vārdā izveidot kontu",
        "susipazinau_su_taisyklem": "Esmu iepazinies ar privātuma politiku un lietošanas noteikumiem",
        "pamirsai_pass": "Aizmirsi paroli?",
        "slaptazodzio_priminimas": "Paroles atgādinājums",
        "slaptazodzio_priminimas_txt": "Lai atgādinātu paroli, ievadiet e-pasta adresi, ko izmantojat pieteikšanās",
        "kopijuoti": "Kopēt",
        "kopijuoti_nuoroda": "Kopēt saiti",
        "grizti_i_prisijungima": "Atgriezties uz pieteikšanās lapu",
        "prisiminti": "Sūtīt kodu",
        "refresh": "Atjaunot",
        "loading": "Notiek ielāde...",
        "atlikti_apklausa": "Novērtēt",
        "statusas": "Statuss",
        "statusas_label": "Statuss",
        "Sustabdyta": "Apturēts",
        "Nepaviešinta": "Nepublicēts",
        "paviesinta": "Publicēts",
        "Paviešinta": "Publicēts",

        kalba_text: ['LT', 'EN', 'RU', 'ET', 'LV'],
        kalba: ['lt', 'en', 'ru', 'et', 'lv'],
        linkaiAdminText: ['Uzņēmumi', 'Rezultāti', 'Punkti', 'Aptaujas'],
        linkaiNeAdminText: ['Veikt novērtējumu', 'Rezultāti', 'Punkti'],
        
        "prenumeratos_valdymas": "Abonēšanas pārvaldība",
        
        'galioja_iki': 'Derīgs līdz',
        'neribotai': 'Neierobežoti',
        'pasirinkti_data': 'Izvēlēties datumu',
        'vieneri_metai': 'Viens gads',

        // Add other translations similarly
        'atlikti_vertinima_label': 'Veikt novērtējumu',
        statusas_text: ['Apturēts', 'Nepublicēts', 'Publicēts'],

        // Chart controls
        "sort_by": "Kārtot pēc",
        "sort_order": "Kārtošanas secība",
        "sort_ascending": "Augošā secībā",
        "sort_descending": "Dilstošā secībā",
        "chart_type": "Grafika tips",
        "bar_chart": "Stabiņu diagramma",
        "pie_chart": "Sektoru diagramma",
        "radar_chart": "Radara diagramma",
        "radial_chart": "Radiālā diagramma",
        "table_view": "Tabula",

        // Registration success messages
        "sekminga_reg": "Reģistrācija veiksmīga!",
        "sekminga_reg_txt1": "Mēs aktivizēsim jūsu profilu vai sazināsimies ar jums 3 darba dienu laikā. Ja rodas jautājumi, lūdzu, sazinieties ar mums pa e-pastu diversity@diversity.lt",

        // Create survey button
        "sukurti_apklausa": "Izveidot aptauju",
        "Create": "Izveidot aptauju",

        // Score translations
        "balas": "Punkti",
        "is_10_galimu": "No 10 iespējamiem",
        "rezultataiTendencijos": "Punkti",
        "rodoma": "Rāda:",

        // Survey type options
        "Darbuotojų apklausa": "Darbinieku aptauja",
        "Įmonės forma": "Organizācijas pārstāvja aptauja",
        "Darbuotojo forma": "Darbinieku aptauja",
        pildytojuTipaiText: ['Darbinieku aptauja', 'Organizācijas pārstāvja aptauja', 'Kopējais rezultāts'],
        pildytojuTipaiText2: ['Darbinieku aptauja', 'Organizācijas pārstāvja aptauja'],
        tipas_text: ['Darbinieku aptauja', 'Organizācijas pārstāvja aptauja'],

        // Filter labels
        "lytysLabel": "Dzimums",
        "laikaiLabel": "Cik ilgi strādā",
        "padetysLabel": "Ģimenes stāvoklis",
        "pareigomsLabel": "Amats organizācijā",
        "religijosLabel": "Vai jūs esat ticīgs?",
        "LGBTLabel": "Vai jūs esat lesbiete, geijs, biseksuāls vai citas neheteroseksuālas seksuālās orientācijas?",
        "negaliosLabel": "Vai jums ir invaliditāte?",
        "neuroskirtingiLabel": "Vai jūs esat neiroatšķirīgs?",
        "pilietybesLabel": "Kāda ir jūsu pilsonība?",
        "orientacijosLabel": "Seksuālā orientācija",

        // Filter arrays
        lytysText: ['Vīrietis', 'Sieviete', 'Cits', 'Neteikšu'],
        amziaiText: ['18-34 gadi', '35-54 gadi', '55-74 gadi', '75 gadi vai vecāks', 'Neteikšu'],
        padetysText: ['Precējies', 'Partnerībā', 'Viens', 'Šķīries', 'Neteikšu', 'Cits'],
        laikaiText: ['Līdz 1 gadam', '1-5 gadi', '5-10 gadi', 'Vairāk nekā 10 gadi'],
        pareigomsText: ['Augstākā līmeņa vadītājs', 'Vidējā līmeņa vadītājs', 'Pirmā līmeņa vadītājs', 'Darbinieks/speciālists', 'Cits'],
        kompiuteriaiText: ['Man ir personālais dators darbam', 'Strādāju pie koplietošanas datoriem', 'Nestrādāju ar datoru'],
        issilavinimaiText: ['Pamatizglītība', 'Vidējā izglītība', 'Augstākā izglītība', 'Cits'],
        religijosText: ['Jā', 'Nē', 'Nezinu', 'Neteikšu'],
        LGBTText: ['Jā', 'Nē', 'Neteikšu'],
        negaliosText: ['Jā', 'Nē', 'Neteikšu'],
        neuroskirtingiText: ['Jā', 'Nē', 'Neteikšu'],
        pilietybesText: [
            'Lietuvas pilsonis(-e)',
            'Latvijas pilsonis',
            'Igaunijas pilsonis(-e)',
            'Kādas ES valsts pilsonis(-e)',
            'Ārpus ES pilsonis(-e)',
            'Man nav pilsonības'
        ],
        orientacijosText: ['Aseksuāls', 'Biseksuāls', 'Homoseksuāls', 'Heteroseksuāls', 'Cits', 'Neteikšu'],
        pilietybes: [
            'Lietuvos pilietė/-is',
            'Latvijos pilietė/-is',
            'Estijos pilietė/-is',
            'ES valstybės pilietė/-is',
            'Ne ES valstybės pilietė/-is',
            'Neturiu pilietybės'
        ],
        neuroskirtingi: ['Taip', 'Ne', 'Nesakysiu'],

        // Individual translations for filter items
        'Vyras': 'Vīrietis',
        'Moteris': 'Sieviete',
        'Kita': 'Cits',
        'Nesakysiu': 'Neteikšu',
        "Lytis": "Dzimums",
        "Amzius": "Vecums",
        "Neuroskirtingas": "Neiroatšķirīgs",
        "Pilietis": "Pilsonība"
    }
}
